import { render, staticRenderFns } from "./data-exports.vue?vue&type=template&id=1a77b4c2&"
import script from "./data-exports.vue?vue&type=script&lang=js&"
export * from "./data-exports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports